import React, { Component } from 'react';
import AuthFunctions from './services/AuthService';
import Session from './auth/Session';
import { Container, Row, Col, Input, Button, Table, Spinner, UncontrolledTooltip } from 'reactstrap';
import { Typeahead } from 'react-bootstrap-typeahead';
import { FaSort } from 'react-icons/fa'
import { DIMENSIONS } from '../util/util';
import { default as ReactSelect } from "react-select";
import { components } from "react-select";
import '../styles/site.css';
import Moment from 'react-moment';
import { NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';

const Option = (props) => {
    return (
        <div>
            <components.Option {...props}>
                <label>{props.label}</label>
            </components.Option>
        </div>
    );
};

export class TABBWeights extends Component {
    static displayName = TABBWeights.name;

    constructor(props) {
        super(props);

        this.state = {
            isAdmin: false,
            isTabbAdmin: false,
            height: 0,
            width: 0,
            loading: false,
            noResults: false,
            modalOpen: false,
            weights: [],
        };
        this.handlePageSizeChange = this.handlePageSizeChange.bind(this);
        window.addEventListener('resize', this.setWindowDimensions);
        document.getElementsByTagName('html')[0].className = "background-ring";

    }

    handlePageSizeChange(event) {
        let pageSize = Number(event.target.value);
        this.setState({ itemsPerPage: pageSize });
        if (this.state.currentPage > Math.ceil(this.state.candidates.length / pageSize)) {
            this.setState({ currentPage: Math.ceil(this.state.candidates.length / pageSize) })
        }
    }

    async componentDidMount() {
        this.setWindowDimensions();
        await this.checkAuthenticated();
        if (this.state.user) {
            const isAdmin = await AuthFunctions.isAdminAsync();
            const isTabbAdmin = await AuthFunctions.isTabbAdminAsync();
            this.setState({ isAdmin: isAdmin, isTabbAdmin: isTabbAdmin });
            if (isTabbAdmin) {
                this.getWeights();
            }
        }
    }

    async checkAuthenticated() {
        var isAuthenticated = await AuthFunctions.getAuthenticatedAsync();
        if (!isAuthenticated) {
            this.props.history.push('/login');
        }
        this.setState({ user: isAuthenticated });
    }

    setWindowDimensions = () => {
        this.setState({
            height: window.innerHeight,
            width: window.innerWidth
        });
    };

    handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            this.searchCandidates();
        }
    }

    render() {
        // Logic for displaying candidates
        const weightData = this.state.weights;

        const renderWeights = weightData.map((weight, i) => {

            return (
                <Row key={i} style={{ marginTop: '10px', marginLeft: '20px' }}>
                    <Col style={{ fontWeight: 'bold' }}>
                        {weight.displayName ?? weight.weightName}
                        {weight.displayText && (
                            <>
                                <br />
                                <span style={{ fontWeight: 'normal', fontSize: '14px' }}>
                                    {weight.displayText}
                                </span>
                            </>
                        )}
                    </Col>
                    <Col>
                        <input
                            type='text'
                            name={weight.weightName}
                            id={weight.weightName}
                            onChange={(e) => {
                                var values = this.state.weights;
                                values[i].weightValue = e.target.value;
                                this.setState({ weights: values });
                            }}
                            value={this.state.weights[i].weightValue}
                        />
                    </Col>
                </Row>
            )
        });

        return (
            <div>
                <Container style={{ marginTop: '50px' }}>
                    <Row>
                        <Col>
                            <NavLink className="nav-button"
                                tag={Link}
                                style={{ padding: '0px' }}
                                to='/TABBMenu'>
                                TABB Tools
                            </NavLink>
                        </Col>
                    </Row>
                    <Row style={{ marginTop: '20px' }}>
                        <Col>
                            <h3>TABB Weights Entry</h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Row style={{ marginTop: '20px' }}>
                                <Col xl='12' lg='12' md='12' sm='12' xs='12'>
                                    <Row style={{ marginTop: '10px', marginLeft: '20px' }}>
                                        <Col style={{ fontWeight: 'bold' }}>Weight Name</Col>
                                        <Col style={{ fontWeight: 'bold' }}>Weight Value</Col>
                                    </Row>

                                    {this.state.loading === true ? (
                                        <Row style={{ marginTop: '10px', marginLeft: '20px' }}>
                                            <Col>
                                                <Spinner color="primary" children='' />
                                            </Col>
                                        </Row>
                                    ) : (
                                        <>
                                            {!this.state.noResults ? (
                                                <>
                                                    {renderWeights}
                                                </>
                                            ) : (
                                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', position: 'absolute', top: '50%', left: '50%', marginTop: '-50px', marginLeft: '-50px' }}>
                                                    <h5>No Results Found</h5>
                                                </div>
                                            )}
                                        </>
                                    )}
                                    <Row style={{ marginTop: '10px', marginLeft: '20px' }}>
                                        <Col></Col>
                                        <Col>
                                            <button onClick={() => { this.saveWeights(); }} style={{ marginTop: '5px', marginBottom: '20px' }}>
                                                Save Weight Values
                                            </button>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </div>
        )
    }

    // clients

    async getWeights() {
        this.setState({ loading: true });
        const token = Session.getToken();
        const response = await fetch('api/tabb/getweights', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        this.setState({ weights: data, loading: false });
    }

    // candidates
    async saveWeights() {
        var weights = this.state.weights;
        this.setState({ loading: true });

        const token = Session.getToken();

        const requestOptions = {
            method: 'POST',
            body: JSON.stringify(weights),
            headers: !token ? { 'Content-Type': 'application/json' } : { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
        };

        try {
            const response = await fetch('api/tabb/updateweights', requestOptions);
            const data = await response.json();
            console.log(data);
        } catch (e) {
            console.log(e);
        }

        this.setState({ loading: false })
    }
}